var _path, _path2, _path3, _g, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPurchaseFailedIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 60,
    viewBox: "0 0 54 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0507812 18.0946V41.9054C0.0508122 42.9918 0.33681 44.0591 0.880041 44.9999C1.42327 45.9409 2.20461 46.7221 3.1455 47.2654L23.7655 59.1708C24.7065 59.7141 25.7738 60 26.8602 60C27.9468 60 29.014 59.7141 29.955 59.1708L50.575 47.2654C51.516 46.7221 52.2972 45.9409 52.8405 44.9999C53.3838 44.0591 53.6697 42.9918 53.6697 41.9054V18.0946C53.6697 17.0082 53.3838 15.9409 52.8405 15.0001C52.2972 14.0591 51.516 13.2778 50.575 12.7346L29.955 0.829221C29.014 0.28599 27.9468 0 26.8602 0C25.7738 0 24.7065 0.28599 23.7655 0.829221L3.1455 12.7346C2.20461 13.2778 1.42327 14.0591 0.880041 15.0001C0.33681 15.9409 0.0508122 17.0082 0.0507812 18.0946Z",
    fill: "#890014"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0507812 18.0946V41.9054C0.0508122 42.9918 0.33681 44.0591 0.880041 44.9999C1.42327 45.9409 2.20461 46.7221 3.1455 47.2654L23.7655 59.1708C24.7065 59.7141 25.7738 60 26.8602 60C27.9468 60 29.014 59.7141 29.955 59.1708L50.575 47.2654C51.516 46.7221 52.2972 45.9409 52.8405 44.9999C53.3838 44.0591 53.6697 42.9918 53.6697 41.9054V18.0946C53.6697 17.0082 53.3838 15.9409 52.8405 15.0001C52.2972 14.0591 51.516 13.2778 50.575 12.7346L29.955 0.829221C29.014 0.28599 27.9468 0 26.8602 0C25.7738 0 24.7065 0.28599 23.7655 0.829221L3.1455 12.7346C2.20461 13.2778 1.42327 14.0591 0.880041 15.0001C0.33681 15.9409 0.0508122 17.0082 0.0507812 18.0946Z",
    fill: "url(#paint0_radial_8340_519119)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8340_519119",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 60
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04504 43.7498L3.04513 43.75C3.36888 44.3107 3.83457 44.7764 4.39553 45.1004C4.39555 45.1004 4.39557 45.1004 4.39559 45.1004L25.0156 57.0057C25.5764 57.3295 26.2126 57.5 26.8602 57.5C27.508 57.5 28.1441 57.3296 28.7049 57.0057L49.325 45.1004C49.8859 44.7765 50.3516 44.3108 50.6755 43.7499L50.6756 43.7497C50.9993 43.1892 51.1697 42.553 51.1697 41.9054V18.0946C51.1697 17.447 50.9993 16.8108 50.6756 16.2503L50.6755 16.2501C50.3516 15.6891 49.8859 15.2235 49.3251 14.8997L49.325 14.8996L28.705 2.99431C28.705 2.9943 28.705 2.99428 28.7049 2.99427C28.144 2.67044 27.5079 2.5 26.8602 2.5C26.2127 2.5 25.5765 2.67046 25.0156 2.99427C25.0155 2.99428 25.0155 2.9943 25.0155 2.99431L4.39553 14.8996L4.39551 14.8996C3.83464 15.2235 3.36892 15.6892 3.04513 16.25L3.04504 16.2502C2.72131 16.8108 2.55081 17.447 2.55078 18.0946L3.04504 43.7498ZM3.04504 43.7498C2.72131 43.1892 2.55081 42.553 2.55078 41.9054C2.55078 41.9053 2.55078 41.9053 2.55078 41.9053M3.04504 43.7498L2.55078 41.9053M2.55078 41.9053V18.0947V41.9053Z",
    stroke: "#143478",
    strokeWidth: 5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8340_519119)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.7161,
    cy: 29.181,
    r: 33.3333,
    fill: "url(#paint1_linear_8340_519119)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.14 19.7103C19.1929 18.7632 17.6574 18.7632 16.7103 19.7103C15.7632 20.6574 15.7632 22.1929 16.7103 23.14L23.5704 30.0001L16.7106 36.8599C15.7635 37.807 15.7635 39.3426 16.7106 40.2897C17.6577 41.2368 19.1932 41.2368 20.1403 40.2897L27.0001 33.4298L33.8589 40.2886C34.806 41.2357 36.3415 41.2357 37.2886 40.2886C38.2357 39.3415 38.2357 37.806 37.2886 36.8589L30.4298 30.0001L37.2889 23.1411C38.236 22.194 38.236 20.6584 37.2889 19.7114C36.3418 18.7643 34.8063 18.7643 33.8592 19.7114L27.0001 26.5704L20.14 19.7103Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.14 19.7103C19.1929 18.7632 17.6574 18.7632 16.7103 19.7103C15.7632 20.6574 15.7632 22.1929 16.7103 23.14L23.5704 30.0001L16.7106 36.8599C15.7635 37.807 15.7635 39.3426 16.7106 40.2897C17.6577 41.2368 19.1932 41.2368 20.1403 40.2897L27.0001 33.4298L33.8589 40.2886C34.806 41.2357 36.3415 41.2357 37.2886 40.2886C38.2357 39.3415 38.2357 37.806 37.2886 36.8589L30.4298 30.0001L37.2889 23.1411C38.236 22.194 38.236 20.6584 37.2889 19.7114C36.3418 18.7643 34.8063 18.7643 33.8592 19.7114L27.0001 26.5704L20.14 19.7103Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8340_519119",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.8603 30) rotate(90) scale(30 26.8095)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F83A56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F83A56",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8340_519119",
    x1: 26.7161,
    y1: -4.15234,
    x2: 26.7161,
    y2: 62.5143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F83A56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1243B"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPurchaseFailedIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/purchase-failed-icon.569933a4836c0f39dabeec6ae9c1f84d.svg";